import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import Sidebar from './Sidebar';

const Layout = () => {
    const isAuthenticated = !!localStorage.getItem("token");

    if (!isAuthenticated) {
        return <Navigate to="/" replace />;
    }

    return (
        <div className="main-layout">
            <Sidebar />
            <div className="content-area">
                <main className="p-3">
                    <Outlet />
                </main>
            </div>
        </div>
    );
};

export default Layout;